var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[_c('v-btn',{attrs:{"icon":""},on:{"click":_vm.showHelp}},[_c('v-icon',{attrs:{"color":_vm.color,"title":_vm.title}},[_vm._v("help_outline")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }